module.exports = __webpack_public_path__ + "fonts/NetflixSansRegular.56bd0039.ttf";